import type { TripPlannerTransportKey } from "../TripPlannerProvider";

export function createTransportKey(
  origin: string,
  destination: string,
): TripPlannerTransportKey {
  return `${origin}_${destination}`;
}
